<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '240px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      let monthList = [], empData = [], hireData = [], quitData = []
      for (let item of chartData.v_92740007) {
        const cnMonth = this.$getCnMonth(this.$day(item.statisticMonth).month())
        if (!monthList.includes(cnMonth)) {
          monthList.push(cnMonth)
        }
        if (item.detailKey === 'officingNum') {
          empData.push(item.detailValue)
        }
        if (item.detailKey === 'inductionNum') {
          hireData.push(item.detailValue)
        }
        if (item.detailKey === 'quitNum') {
          quitData.push(item.detailValue)
        }
      }
      this.chart.setOption({
        backgroundColor: '#FFFFFF',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: '4%',
          data: [
            {
              name: this.$t('onJob')
            },
            {
              name: this.$t('joined')
            },
            {
              name: this.$t('resignation')
            }
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: monthList
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}人'
            }
          }
        ],
        series: [
          {
            name: this.$t('resignation'),
            type: 'bar',
            stack: 'emp',
            barWidth: 30,
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#6EC58B'
            },
            data: quitData
          },
          {
            name: this.$t('joined'),
            type: 'bar',
            stack: 'emp',
            barWidth: 30,
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#3371C5'
            },
            data: hireData
          },
          {
            name: this.$t('onJob'),
            type: 'bar',
            stack: 'emp',
            barWidth: 30,
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#0093AB',
              borderRadius: [4, 4, 0, 0]
            },
            data: empData
          },
        ]
      })
    }
  }
}
</script>
